
<!--
  ~ VNCmail : A whole new experience in enterprise email communication.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->

<div class="mail-dialog">
    <vnc-header class="message" title="{{ 'ATTACH_CONTACT_LBL' | translate }}" type="title-close" size="l"
        (onCloseClick)="close()" [showCloseIcon]="true" closeIconToolTip="{{ 'CLOSE' | translate }}">
    </vnc-header>
    <div class="mail__dialog-body mail__dialog-body--pad">
        <div class="content">
            <div class="contact-loading-spinner" *ngIf="isLoading">
                <vp-custom-spinner></vp-custom-spinner>
            </div>
            <div class="search_div">
                <div class="searchField">
                <vnc-input
                    label="{{ 'URL' | translate }}"
                    [form]="searchControl"
                    [showClear]="true"
                    leadingIconName="mdi-magnify"
                    (leadingIconClick)="searchContacts()"
                    placeholder="{{ 'SEARCH_DOT' | translate }}"
                    size="m"
                    type="text">
                </vnc-input>
                </div>
                <div class="pagging">
                    <button mat-button (click)="loadPreviousContact()" [disabled]="offset===0">
                        <mat-icon class="disable-select">keyboard_arrow_left</mat-icon>
                    </button>
                    <span *ngIf="limit !== 0">{{offset + 1 }} - {{limit + offset}}</span>
                    <button mat-button (click)="loadNextContact()" [disabled]="!isMoreContact">
                        <mat-icon class="disable-select">keyboard_arrow_right</mat-icon>
                    </button>
                </div>
            </div>
            <div class="tree_email_div">
                <div class="tree_div">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="folder-tree">
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                            <li class="mat-tree-node" (click)="folderItem(node)"
                                [class.selected-class]="!!selectedFolder && selectedFolder !== null && node.id === selectedFolder.id">
                                <button mat-icon-button disabled></button>
                                <mat-icon [style.color]="node.rgb" *ngIf="node.id !==''">folder</mat-icon>
                                <span *ngIf="node.id === '7'">{{ 'CONTACTS_TITLE' | translate }}</span>
                                <span *ngIf="node.id === '13'">{{ 'EMAILED_CONTACTS_TITLE' | translate }}</span>
                                <span *ngIf="node.id !== '7' && node.id !== '13'">{{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}</span>
                            </li>
                        </mat-tree-node>
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                            <li>
                                <div class="mat-tree-node" (click)="folderItem(node)"
                                    [class.selected-class]="!!selectedFolder && selectedFolder !== null && node.id === selectedFolder.id">
                                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                                        <mat-icon class="mat-icon-rtl-mirror">
                                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                        </mat-icon>
                                    </button>
                                    <mat-icon [style.color]="node.rgb" *ngIf="node.id !==''">folder</mat-icon>
                                    <span *ngIf="node.id === '7'">{{ 'CONTACTS_TITLE' | translate }}</span>
                                    <span *ngIf="node.id === '13'">{{ 'EMAILED_CONTACTS_TITLE' | translate }}</span>
                                    <span *ngIf="node.id !== '7' && node.id !== '13'">{{mailService?.getFolderNameKey(node.name, MailConstants?.SYSTEM_FOLDERS)}}</span>
                                </div>
                                <ul [class.folder-tree-invisible]="!treeControl.isExpanded(node)">
                                    <ng-container matTreeNodeOutlet></ng-container>
                                </ul>
                            </li>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
                <div class="email_list">
                    <div *ngIf="contacts.length === 0" class="no-contact-found">
                        <span>{{ 'NO_CONTACTS_FOUND_MSG' | translate }}</span>
                    </div>
                    <div *ngIf="contacts.length > 0">
                        <div *ngFor="let contact of contacts; index as i;">
                            <div class="suggestion" (click)="selectContact(contact, i, $event)"
                                [ngClass]="{'is-selected': isSelectedEmailContacts(contact)}">
                                <vp-avatar [type]="'mail-detail-avatar'"
                                    [user]="{firstLastCharacters: contact.firstLastCharacter, color: '#317bbc', email: contact.email}">
                                </vp-avatar>
                                <div class="email_name_division">
                                    <div class="disable-select subject_date">
                                        <div class="subject">
                                            {{contact.fullName}}
                                        </div>
                                    </div>
                                    <p class="disable-select">{{contact.email}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <vnc-footer class="calendar-menu-actio desktop_view" [secondaryLabel]="'CANCEL_MAIL_LABEL' | translate | uppercase"
        [primaryLabel]="'ATTACH_LBL' | translate | uppercase" [ngClass]="{ 'dfb-theme': (currentTheme === 'dfb' && !isFluid) }"
        [type]="'secondary-primary'" [color]="'white'" (onSecondaryClick)="close()"
        [isPrimaryDisabled]="selectedContacts.length === 0" (onPrimaryClick)="attachContacts()">
    </vnc-footer>
</div>
<ng-template #closeIcon>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/close-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M18.9497475,5.05025253 C19.3402718,5.44077682 19.3402718,6.0739418 18.9497475,6.46446609 L13.4142136,12 L18.9497475,17.5355339 C19.3402718,17.9260582 19.3402718,18.5592232 18.9497475,18.9497475 C18.5592232,19.3402718 17.9260582,19.3402718 17.5355339,18.9497475 L12,13.4142136 L6.46446609,18.9497475 C6.0739418,19.3402718 5.44077682,19.3402718 5.05025253,18.9497475 C4.65972824,18.5592232 4.65972824,17.9260582 5.05025253,17.5355339 L10.5857864,12 L5.05025253,6.46446609 C4.65972824,6.0739418 4.65972824,5.44077682 5.05025253,5.05025253 C5.44077682,4.65972824 6.0739418,4.65972824 6.46446609,5.05025253 L12,10.5857864 L17.5355339,5.05025253 C17.9260582,4.65972824 18.5592232,4.65972824 18.9497475,5.05025253 Z" id="Path" fill="#8B96A0"></path>
      </g>
    </svg>
</ng-template>